import axios from 'axios';
import { attachResponseInterceptor } from './response-interceptor';
const baseURL = process.env.REACT_APP_API_URL;
export const itwApi = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});
// Attach middleware interceptors
// We don't use bearer, we're using cookies for authentication
// attachRequestInterceptor(itwApi);
attachResponseInterceptor(itwApi);
